/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseControllerErrorResponse,
  ExternalBaseControllerErrorResponseList,
  ExternalMerchantDto,
  ExternalPaymentOrderFilterDto,
  GetFilterData1ParamsDataTypeEnum,
  GetFilterData2ParamsDataTypeEnum,
  GetFilterDataParamsDataTypeEnum,
  MerchantBalanceByCurrencyFilterDto,
  MerchantBalanceByCurrencyResponseDto,
  MerchantBalanceCsvFilterDto,
  MerchantBalanceDto1,
  MerchantBalanceFilterDto,
  MerchantSettlementCsvFilterDto,
  MerchantSettlementDto1,
  MerchantSettlementFilterDto,
  Pageable,
  PaymentOrderExportRequest,
  PaymentOrderExportResponse,
  PaymentOrderSearchListResponse1,
  PayoutOrderExportRequest,
  PayoutOrderExportResponse,
  PayoutOrderFilterDto,
  PayoutOrderListResponse1,
  ReconciliationReportExportRequest,
  ReconciliationReportExportResponse,
  RedirectLink,
  ScheduledReportDto1,
  SearchReportsDto,
  Sort,
  UpdateEnabledRequest,
  ValidationErrorResponse,
  ValidationErrorResponseV2,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags external-merchant-report-rest-controller
   * @name UpdateEnabled
   * @request PUT:/external-merchant-admin/v1/reports/by-identity/{identity}/scheduling/enabled
   */
  updateEnabled = (
    identity: string,
    data: UpdateEnabledRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/reports/by-identity/${identity}/scheduling/enabled`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-payout-order-controller
   * @name GetAllPayoutOrders
   * @request POST:/external-merchant-admin/v1/merchants/payout/order/find
   */
  getAllPayoutOrders = (
    query: {
      pageable: Pageable;
    },
    data: PayoutOrderFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      PayoutOrderListResponse1,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/payout/order/find`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-report-rest-controller
   * @name Export
   * @request POST:/external-merchant-admin/v1/merchants/payout/order/export
   */
  export = (data: PayoutOrderExportRequest, params: RequestParams = {}) =>
    this.request<
      PayoutOrderExportResponse,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/payout/order/export`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-payment-order-controller
   * @name GetAll
   * @request POST:/external-merchant-admin/v1/merchants/payment/order/find
   */
  getAll = (
    query: {
      pageable: Pageable;
    },
    data: ExternalPaymentOrderFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      PaymentOrderSearchListResponse1,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/payment/order/find`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-report-rest-controller
   * @name Export1
   * @request POST:/external-merchant-admin/v1/merchants/payment/order/export
   */
  export1 = (data: PaymentOrderExportRequest, params: RequestParams = {}) =>
    this.request<
      PaymentOrderExportResponse,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/payment/order/export`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-report-rest-controller
   * @name FindPaymentReports
   * @request POST:/external-merchant-admin/v1/merchants/order/reports/search
   */
  findPaymentReports = (
    query: {
      pageable: Pageable;
    },
    data: SearchReportsDto,
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduledReportDto1,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/order/reports/search`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-settlement-controller
   * @name FindMerchantSettlements
   * @request POST:/external-merchant-admin/v1/merchants/balances/settlements/find
   */
  findMerchantSettlements = (
    query: {
      pageable: Pageable;
    },
    data: MerchantSettlementFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MerchantSettlementDto1,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/settlements/find`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-settlement-controller
   * @name ExportMerchantSettlementsToCsv
   * @request POST:/external-merchant-admin/v1/merchants/balances/settlements/csv
   */
  exportMerchantSettlementsToCsv = (
    data: MerchantSettlementCsvFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      string,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/settlements/csv`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-balance-controller
   * @name ExportReconciliationReport
   * @request POST:/external-merchant-admin/v1/merchants/balances/reconciliation/export
   */
  exportReconciliationReport = (
    data: ReconciliationReportExportRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ReconciliationReportExportResponse,
      | (ExternalBaseControllerErrorResponseList | BaseControllerErrorResponse)
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/reconciliation/export`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-balance-controller
   * @name FindMerchantBalances
   * @request POST:/external-merchant-admin/v1/merchants/balances/find
   */
  findMerchantBalances = (
    query: {
      pageable: Pageable;
    },
    data: MerchantBalanceFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MerchantBalanceDto1,
      | (ExternalBaseControllerErrorResponseList | BaseControllerErrorResponse)
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/find`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-balance-controller
   * @name FindMerchantBalancesByMerchantIdAndCurrency
   * @request POST:/external-merchant-admin/v1/merchants/balances/currency/find
   */
  findMerchantBalancesByMerchantIdAndCurrency = (
    query: {
      sort: Sort;
    },
    data: MerchantBalanceByCurrencyFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      MerchantBalanceByCurrencyResponseDto,
      | (ExternalBaseControllerErrorResponseList | BaseControllerErrorResponse)
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/currency/find`,
      method: "POST",
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-balance-controller
   * @name ExportMerchantBalancesToCsv
   * @request POST:/external-merchant-admin/v1/merchants/balances/csv
   */
  exportMerchantBalancesToCsv = (
    data: MerchantBalanceCsvFilterDto,
    params: RequestParams = {},
  ) =>
    this.request<
      string,
      | (ExternalBaseControllerErrorResponseList | BaseControllerErrorResponse)
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/csv`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-controller
   * @name GetExternalMerchantsV2
   * @request GET:/external-merchant-admin/v2/merchants/external
   */
  getExternalMerchantsV2 = (params: RequestParams = {}) =>
    this.request<
      ExternalMerchantDto[],
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v2/merchants/external`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags user-controller
   * @name GetRedirectLink
   * @request GET:/external-merchant-admin/v1/user/change-password
   */
  getRedirectLink = (params: RequestParams = {}) =>
    this.request<
      RedirectLink,
      | (ExternalBaseControllerErrorResponseList | BaseControllerErrorResponse)
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/user/change-password`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-filter-data-controller
   * @name GetPayoutMethodNames
   * @request GET:/external-merchant-admin/v1/payout/system-group-forms/search-filter
   */
  getPayoutMethodNames = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/api/v1/payout/system-group-forms/search-filter`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-filter-data-controller
   * @name GetPaymentMethodNames
   * @request GET:/external-merchant-admin/v1/payment/system-group-forms/search-filter
   */
  getPaymentMethodNames = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/api/v1/payment/system-group-forms/search-filter`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-filter-data-controller
   * @name GetMerchantSites
   * @request GET:/external-merchant-admin/v1/merchants/sites/search-filter
   */
  getMerchantSites = (params: RequestParams = {}) =>
    this.request<Record<string, string>, any>({
      path: `/api/v1/merchants/sites/search-filter`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-payout-order-controller
   * @name GetFilterData
   * @request GET:/external-merchant-admin/v1/merchants/payout/order/search-filter
   */
  getFilterData = (
    query: {
      dataType: GetFilterDataParamsDataTypeEnum;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      string[],
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/payout/order/search-filter`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-payment-order-controller
   * @name GetFilterData1
   * @request GET:/external-merchant-admin/v1/merchants/payment/order/search-filter
   */
  getFilterData1 = (
    query: {
      dataType: GetFilterData1ParamsDataTypeEnum;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      string[],
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/payment/order/search-filter`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-report-rest-controller
   * @name FindPaymentReports1
   * @request GET:/external-merchant-admin/v1/merchants/order/reports
   */
  findPaymentReports1 = (
    query: {
      pageable: Pageable;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ScheduledReportDto1,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/order/reports`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-controller
   * @name GetExternalMerchant
   * @request GET:/external-merchant-admin/v1/merchants/external
   * @deprecated
   */
  getExternalMerchant = (params: RequestParams = {}) =>
    this.request<
      ExternalMerchantDto,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/external`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-balance-controller
   * @name GetFilterData2
   * @request GET:/external-merchant-admin/v1/merchants/balances/search-filter
   */
  getFilterData2 = (
    query: {
      dataType: GetFilterData2ParamsDataTypeEnum;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      string[],
      | (ExternalBaseControllerErrorResponseList | BaseControllerErrorResponse)
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/merchants/balances/search-filter`,
      method: "GET",
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags external-merchant-report-rest-controller
   * @name Delete
   * @request DELETE:/external-merchant-admin/v1/reports/by-identity/{identity}
   */
  delete = (identity: string, params: RequestParams = {}) =>
    this.request<
      void,
      | (
          | ValidationErrorResponse
          | BaseControllerErrorResponse
          | ValidationErrorResponseV2
        )
      | BaseControllerErrorResponse
      | ExternalBaseControllerErrorResponseList
    >({
      path: `/api/v1/reports/by-identity/${identity}`,
      method: "DELETE",
      ...params,
    });
}
